import { createStore, applyMiddleware, compose, combineReducers } from 'redux'
import { connectRouter, routerMiddleware } from 'connected-react-router'
import thunkMiddleware from 'redux-thunk'
import { createLogger } from 'redux-logger'
import { createBrowserHistory } from 'history'
import { routerRootUrl } from 'config/api.config.js'

import * as reducers from './reducers'
import * as customMiddlewares from './middlewares'

export const history = createBrowserHistory({ basename: routerRootUrl })

const initStore = () => {
  const rootReducer = combineReducers({ router: connectRouter(history), ...reducers })
  const middlewares = [...Object.values(customMiddlewares), routerMiddleware(history), thunkMiddleware]

  if (process.env.NODE_ENV !== 'production' || sessionStorage.reduxLogger) {
    middlewares.push(
      createLogger({
        collapsed: true,
        predicate: (getState, action) => !/see|hide|timeout/i.test(action.type),
      })
    )
  }

  return createStore(rootReducer, compose(applyMiddleware(...middlewares)))
}

const store = (window.store = initStore())

export default store
